import { TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA } from '../../../../../config/tables'
import CpaSinCtgConfirmadoDefinitivamente from '../../../../../models/camiones/cpa_sin_ctg_confirmado_definitivamente'
import { COLUMNS_CAMIONES_SIN_DEFINITIVA, COLUMNS_CAMIONES_SIN_DEFINITIVA_TO_PRINT } from './constantesCamionesSinDefinitva'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { toast } from 'react-toastify'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA
    })
    CpaSinCtgConfirmadoDefinitivamente.getListado().then(callback)
    function callback (data) {
      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de Cartas de Porte sin confirmar definitivamente',
        data,
        COLUMNS_CAMIONES_SIN_DEFINITIVA_TO_PRINT,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_SIN_DEFINITIVA,
          data: data,
          title: `Listado de Cartas de Porte sin confirmar definitivamente`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: true, rowsPerPage: 50, rowsPerPageOptions: [50, 100] }
        },
        id: TABLA_PEDIDO_CAMIONES_SIN_DEFINITIVA
      })
    }
  }
}

export function confirmarDefinitivamente (numero) {
  return (dispatch) => {
    console.log('por confirmar definitivamente...', numero)
    if (numero !== null) {
      return CpaSinCtgConfirmadoDefinitivamente.confirmarDefinitivamente(numero)
        .then(result => {
          console.log('Result', result)
          // falta algo en el result, da error el substr
          const resultado = (result.length > 0)
            ? result[0].cartaDePorteAutomotorIngresoUpdate
            : (result.cartaDePorteAutomotorIngresoUpdate)
              ? result.cartaDePorteAutomotorIngresoUpdate
              : null
          console.log('Resultado', resultado)
          if (resultado !== null) {
            const data = resultado.substr(1, resultado.length - 2).split(',')
            console.log('Data es ', data)
            if (data[3] === 'D') {
              toast.info('Confirmado definitivamente en ARCA')
              return { resultado: 'ok' }
            } else {
              toast.error('Hubo problemas al confirmar definitivamente en ARCA')
              return { resultado: 'error' }
            }
          } else {
            toast.error('Hubo problemas al confirmar definitivamente en ARCA')
            return { resultado: 'error' }
          }
        })
    } else {
      toast.error('No se puede verificar el número de CTG')
      return { resultado: 'error' }
    }
  }
}

export function obtenerTotales () {
  return (dispatch) => {
    return CpaSinCtgConfirmadoDefinitivamente.getListadoTotales()
      .then(result => {
        console.log('Result', result)
        if (result) {
          dispatch({
            type: 'CTG_SIN_CONFIRMACION_TOTALES',
            estado: result.estado,
            pesoNetoOrigen: result.pesoNetoOrigen,
            pesoNetoDescargado: result.pesoNetoDescargado
          })
        }
      })
  }
}
